import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import Carriers from 'components/ShipmentSettings/Carriers';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        <Carriers />
      </SiteContent>
    </ContentLayout>
  );
};
